import { inspect } from 'util';

class ServerError extends Error {
  constructor(message: string, error: any) {
    super(message, {
      cause: inspect(error, { showHidden: false, depth: 2 }),
    });
  }

  get name() {
    return `[ERROR]`;
  }
}

export const logError = (message: string, error: any) =>
  console.error(new ServerError(message, error));
